import { blueGrey, deepOrange } from "@mui/material/colors";
import StatusChip from "@entrilia/shared/components/StatusChip";
import { makeModeAwareAccent } from "@entrilia/shared/utilities/colorHelper";
import { autoFormatCamelCase } from "@entrilia/shared/utilities/stringHelper";
import type { ChecklistTaskStatus } from "../../../api/types/objectTypes";
import { checklistTaskStatusCaptionsMap } from "../../../utilities/enumCaptions";

interface Props {
  status: ChecklistTaskStatus;
}

const ChecklistTaskStatusTag = ({ status }: Props) => {
  const label = checklistTaskStatusCaptionsMap[status] ?? autoFormatCamelCase(status);

  switch (status) {
    case "ToDo": {
      return <StatusChip withDot label={label} color={(t) => t.palette.text.secondary} />;
    }
    case "Done": {
      return <StatusChip withDot label={label} color={(t) => t.palette.success.main} />;
    }
    case "Waived": {
      return <StatusChip withDot label={label} color={(t) => makeModeAwareAccent(t, deepOrange)} />;
    }
    case "NotApplicable": {
      return <StatusChip withDot label={label} color={(t) => makeModeAwareAccent(t, blueGrey)} />;
    }
    default: {
      return null;
    }
  }
};

export default ChecklistTaskStatusTag;
